"use strict";

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_adn3sjlop = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repositories/Search.js";
  var hash = "7f4dd9666f8ceb541828caa06bfb8c641e9a815d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repositories/Search.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "1": {
        start: {
          line: 13,
          column: 39
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 26,
          column: 18
        },
        end: {
          line: 26,
          column: 29
        }
      },
      "3": {
        start: {
          line: 27,
          column: 42
        },
        end: {
          line: 27,
          column: 54
        }
      },
      "4": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 44,
          column: 4
        }
      },
      "5": {
        start: {
          line: 47,
          column: 0
        },
        end: {
          line: 58,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 29
          },
          end: {
            line: 13,
            column: 30
          }
        },
        loc: {
          start: {
            line: 13,
            column: 39
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "Search",
        decl: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 15
          }
        },
        loc: {
          start: {
            line: 25,
            column: 3
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 25
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "7f4dd9666f8ceb541828caa06bfb8c641e9a815d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

require("@material-ui/icons");

var _ = require(".");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_adn3sjlop.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_adn3sjlop.f[0]++;
  cov_adn3sjlop.s[1]++;
  return {
    root: {
      overflow: 'auto',
      height: '100%'
    }
  };
}));

function Search(_ref) {
  var defaultOwner = _ref.defaultOwner,
      defaultQuery = _ref.defaultQuery,
      onRepository = _ref.onRepository,
      config = _ref.config;
  cov_adn3sjlop.f[1]++;
  var classes = (cov_adn3sjlop.s[2]++, useStyles());

  var _ref2 = (cov_adn3sjlop.s[3]++, (0, _react.useState)([])),
      _ref3 = _slicedToArray(_ref2, 2),
      repositories = _ref3[0],
      setRepositories = _ref3[1];

  cov_adn3sjlop.s[4]++;
  return /*#__PURE__*/_react.default.createElement(_core.List, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_.SearchForm, {
    defaultOwner: defaultOwner,
    defaultQuery: defaultQuery,
    onRepositories: setRepositories,
    config: config
  }), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_.Repositories, {
    repositories: repositories,
    onRepository: onRepository,
    config: config
  }));
}

cov_adn3sjlop.s[5]++;
Search.propTypes = {
  /** Prefill the owner search field. */
  defaultOwner: _propTypes.default.string,

  /** Prefill the query search field. */
  defaultQuery: _propTypes.default.string,

  /** Function to call when repository is selected. */
  onRepository: _propTypes.default.func.isRequired,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = Search;
exports.default = _default;